import { useInsertionEffect } from 'react';
// Los estilos del editor del documento al cliente (F4c · diseño): lo que no se puede decir en línea (hover, foco,
// arrastre, movimiento). Mismo lenguaje que el resto del Pricer: pizarra clara, acento `--primary`, radios de 8-12 px.
// Cada pieza lo monta (son piezas sueltas que F5 reusa) pero la hoja se inyecta UNA sola vez en el documento.
// Movimiento: sólo `transform` y colores, ≤ 160 ms; con «reducir movimiento» no hay nada que se mueva.
const ID_DE_LA_HOJA = 'dd-estilos-del-editor';

const CSS = `
      .dd-btn {
        display: inline-flex; align-items: center; justify-content: center; gap: 6px;
        min-height: 32px; padding: 0 12px; border: 1px solid hsl(var(--muted-foreground) / 0.4); background: hsl(var(--card)); color: hsl(var(--foreground));
        border-radius: 8px; font-size: 13px; font-weight: 500; line-height: 1; white-space: nowrap;
        transition: background-color 150ms ease-out, border-color 150ms ease-out, color 150ms ease-out, transform 120ms ease-out;
      }
      .dd-btn:hover:not(:disabled) { background: hsl(var(--muted)); border-color: hsl(var(--muted-foreground) / 0.6); }
      .dd-btn:active:not(:disabled) { transform: scale(0.97); }
      .dd-btn:focus-visible, .dd-iconbtn:focus-visible, .dd-grip:focus-visible, .dd-indice-item:focus-visible,
      .dd-divisor:focus-visible, .dd-celda:focus-visible, .dd-linkbtn:focus-visible, .dd-modo:focus-visible {
        outline: 2px solid hsl(var(--primary)); outline-offset: 2px;
      }
      .dd-btn:disabled, .dd-iconbtn:disabled { opacity: 0.45; cursor: not-allowed; }
      .dd-btn-chico { min-height: 28px; padding: 0 10px; font-size: 12px; }
      .dd-btn-agregar { border-style: dashed; color: hsl(var(--foreground) / 0.8); background: hsl(var(--muted) / 0.5); }
      .dd-btn-agregar:hover:not(:disabled) { border-style: solid; border-color: hsl(var(--primary)); color: hsl(var(--primary)); background: hsl(var(--info-suave)); }
      .dd-btn-peligro:hover:not(:disabled) { color: hsl(var(--bloqueo)); border-color: hsl(var(--bloqueo-borde)); background: hsl(var(--bloqueo-suave)); }
      .dd-iconbtn {
        display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; padding: 0;
        border: 1px solid transparent; background: transparent; color: hsl(var(--muted-foreground)); border-radius: 6px;
        transition: background-color 150ms ease-out, color 150ms ease-out, transform 120ms ease-out;
      }
      .dd-iconbtn:hover:not(:disabled) { background: hsl(var(--muted)); color: hsl(var(--foreground)); }
      .dd-iconbtn:active:not(:disabled) { transform: scale(0.94); }
      .dd-iconbtn.dd-peligro:hover:not(:disabled) { background: hsl(var(--bloqueo-suave)); color: hsl(var(--bloqueo)); }

      .dd-tarjeta { background: hsl(var(--card)); border: 1px solid hsl(var(--border)); border-radius: 12px; }
      .dd-tarjeta-cab { display: flex; align-items: center; gap: 12px; padding: 16px 20px; }
      .dd-tarjeta-cuerpo { padding: 4px 20px 20px; }
      .dd-titulo { margin: 0; font-size: 16px; font-weight: 600; color: hsl(var(--foreground)); letter-spacing: -0.01em; }
      .dd-resumen { margin: 2px 0 0; font-size: 13px; color: hsl(var(--muted-foreground)); line-height: 1.45; }
      .dd-apagada { padding: 0 20px 18px; font-size: 13px; color: hsl(var(--muted-foreground)); }

      .dd-modo {
        flex: 1; text-align: left; padding: 14px 16px; border-radius: 10px; background: hsl(var(--card)); color: hsl(var(--foreground));
        border: 1px solid hsl(var(--muted-foreground) / 0.4); cursor: pointer;
        transition: background-color 150ms ease-out, border-color 150ms ease-out, transform 120ms ease-out;
      }
      .dd-modo:hover:not(:disabled) { border-color: hsl(var(--primary)); }
      .dd-modo:active:not(:disabled) { transform: scale(0.985); }
      .dd-modo[aria-pressed='true'] { background: hsl(var(--info-suave)); border-color: hsl(var(--primary)); box-shadow: 0 0 0 1px hsl(var(--primary)); }
      .dd-modo:disabled { cursor: not-allowed; opacity: 0.6; }

      .dd-bloque { border: 1px solid hsl(var(--muted-foreground) / 0.4); border-radius: 12px; background: hsl(var(--card)); position: relative; }
      .dd-bloque[data-arrastrando='true'] { opacity: 0.45; }
      .dd-bloque[data-destino='antes']::before, .dd-bloque[data-destino='despues']::after {
        content: ''; position: absolute; left: 12px; right: 12px; height: 3px; border-radius: 2px; background: hsl(var(--primary));
      }
      .dd-bloque[data-destino='antes']::before { top: -8px; }
      .dd-bloque[data-destino='despues']::after { bottom: -8px; }
      .dd-bloque-cab { display: flex; align-items: center; gap: 8px; padding: 10px 12px; flex-wrap: wrap; }
      .dd-bloque-num {
        display: inline-flex; align-items: center; justify-content: center; min-width: 26px; height: 26px; border-radius: 8px;
        background: hsl(var(--info-suave)); color: hsl(var(--primary)); font-size: 12px; font-weight: 700;
      }
      .dd-grip { cursor: grab; touch-action: none; }
      .dd-grip:active { cursor: grabbing; }
      .dd-seccion { border: 1px solid hsl(var(--border)); border-radius: 10px; background: hsl(var(--muted) / 0.5); padding: 14px; }

      .dd-tabla-marco { overflow-x: auto; border: 1px solid hsl(var(--muted-foreground) / 0.4); border-radius: 10px; background: hsl(var(--card)); }
      .dd-tabla { border-collapse: separate; border-spacing: 0; width: 100%; font-size: 13px; }
      .dd-tabla th, .dd-tabla td { border-right: 1px solid hsl(var(--border)); border-bottom: 1px solid hsl(var(--border)); padding: 0; vertical-align: top; background: hsl(var(--card)); }
      .dd-tabla th { background: hsl(var(--muted)); }
      .dd-tabla tr:last-child td { border-bottom: none; }
      .dd-tabla th:last-child, .dd-tabla td:last-child { border-right: none; }
      .dd-tabla .dd-col { min-width: 190px; }
      .dd-tabla .dd-fila-num { vertical-align: top; width: 44px; min-width: 44px; text-align: center; background: hsl(var(--muted) / 0.5); color: hsl(var(--muted-foreground)); font-size: 12px; font-weight: 600; padding-top: 12px; }
      .dd-tabla .dd-fila-acc { width: 44px; min-width: 44px; background: hsl(var(--muted) / 0.5); text-align: center; padding-top: 6px; }
      .dd-tabla .dd-fila-num .dd-iconbtn { display: flex; }
      .dd-celda {
        display: block; width: 100%; border: none; border-radius: 0; background: transparent; resize: none; overflow: hidden;
        padding: 10px 12px; font: inherit; font-size: 13px; line-height: 1.45; color: hsl(var(--foreground)); min-height: 40px;
      }
      .dd-celda:focus-visible { outline-offset: -2px; background: hsl(var(--card)); }
      .dd-celda:disabled { color: hsl(var(--muted-foreground)); background: hsl(var(--muted) / 0.5); cursor: not-allowed; }
      .dd-celda-cab { font-weight: 600; }
      .dd-tabla-acciones { display: flex; gap: 8px; margin-top: 10px; align-items: center; flex-wrap: wrap; }

      .dd-indice-fila {
        display: flex; align-items: center; gap: 6px; padding-right: 10px; border-left: 3px solid transparent;
        border-radius: 8px; transition: background-color 150ms ease-out;
      }
      .dd-indice-fila:hover { background: hsl(var(--muted)); }
      .dd-indice-fila[data-activa='true'] { background: hsl(var(--info-suave)); border-left-color: hsl(var(--primary)); }
      .dd-indice-item {
        display: flex; align-items: center; gap: 10px; flex: 1; min-width: 0; text-align: left; padding: 9px 4px 9px 10px;
        border: none; background: transparent; color: hsl(var(--foreground)); border-radius: 8px; cursor: pointer;
      }
      .dd-indice-fila[data-estado='apagada'] .dd-indice-nombre { color: hsl(var(--muted-foreground)); }

      .dd-divisor { width: 12px; cursor: col-resize; touch-action: none; position: relative; flex: none; }
      .dd-divisor::after { content: ''; position: absolute; left: 5px; top: 0; bottom: 0; width: 2px; border-radius: 2px; background: hsl(var(--border)); transition: background-color 150ms ease-out; }
      .dd-divisor:hover::after, .dd-divisor[data-activo='true']::after { background: hsl(var(--primary)); }

      .dd-linkbtn { background: none; border: none; padding: 0; color: hsl(var(--primary)); font-size: 12px; text-decoration: underline; cursor: pointer; border-radius: 4px; }

      @media (prefers-reduced-motion: reduce) {
        .dd-btn, .dd-iconbtn, .dd-modo, .dd-indice-fila, .dd-divisor::after { transition: none; }
        .dd-btn:active:not(:disabled), .dd-iconbtn:active:not(:disabled), .dd-modo:active:not(:disabled) { transform: none; }
      }
    `;

export function EstilosDelEditor() {
  useInsertionEffect(() => {
    if (document.getElementById(ID_DE_LA_HOJA)) return;
    const hoja = document.createElement('style');
    hoja.id = ID_DE_LA_HOJA;
    hoja.textContent = CSS;
    document.head.appendChild(hoja);
  }, []);
  return null;
}
